import type { GooglePayConfig } from '../types/google-pay-config.type';
import { InjectionToken } from '@angular/core';

export const GOOGLE_PAY_CONFIG = new InjectionToken<GooglePayConfig>('Google Pay config');
